import { of as observableOf,  Observable } from 'rxjs';
import { dematerialize, delay, materialize, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { siteMock, jobsMock, jobMock, postingSuppressionsMock, geoLocationMock } from '../mock-data';

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // wrap in delayed observable to simulate server api call
    return observableOf(null).pipe(
      mergeMap(() => {

        // GET /career-live-sites/{domain}
        if (request.url.includes('/api/career-live-sites') && request.method === 'GET') {
          return observableOf(new HttpResponse({ status: 200, body: siteMock }));
        }

        // POST /jobs/search
        if (request.url.includes('/api/jobs/search') && request.method === 'POST') {
          return observableOf(new HttpResponse({ status: 200, body: jobsMock }));
        }

        // GET /jobs/{id}
        if (request.url.includes('/api/jobs') && request.method === 'GET') {
          return observableOf(new HttpResponse({ status: 200, body: jobMock }));
        }

        // GET /posting-suppressions
        if (request.url.includes('/api/posting-suppressions') && request.method === 'GET') {
          return observableOf(new HttpResponse({ status: 200, body: postingSuppressionsMock }));
        }

        // GET /geolocate
        if (request.url.includes('/api/geolocate') && request.method === 'GET') {
          return observableOf(new HttpResponse({ status: 200, body: geoLocationMock }));
        }

        // POST /events
        if (request.url.includes('/api/events') && request.method === 'POST') {
          return observableOf(new HttpResponse({ status: 200 }));
        }

        // pass through any requests not handled above
        return next.handle(request);

      }),

      // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
      materialize(),
      delay(500),
      dematerialize()
    );
  }
}
